<template>
  <div class="index-page">
    <div class="main-pics">
      <div class="banner" v-if="banners.length > 0">
        <a-carousel autoplay>
          <div class="item" v-for="item in banners.slice(0,1)" :key="item.essayId">
            <a href="https://zhitu.sozdata.com/#/site_race_detail?id=195" target="_blank" rel="noopener noreferrer">
              <img :src="item.imgUrl" alt="" />
              <div class="title">{{ item.title }}</div>
            </a>
          </div>
          <div class="item" v-for="item in banners" :key="item.essayId">
            <router-link
              :to="{ path: '/view/detail', query: { id: item.essayId } }"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img :src="item.imgUrl" alt="" />
              <div class="title">{{ item.title }}</div>
            </router-link>
          </div>
        </a-carousel>
      </div>
      <div class="actives" v-if="active && active.autoId">
        <div class="title">最新活动</div>
        <div class="pic">
          <router-link
            :to="{ path: '/activity', query: { id: active.autoId } }"
          >
            <img :src="imgSiteUrl + active.imgUrl" alt="" />
          </router-link>
        </div>
        <div class="desc">{{ active.title }}</div>
        <div class="time">
          活动时间：{{ active.startDate }}——{{ active.endDate }}
        </div>
      </div>
    </div>
    <div class="main-list">
      <div class="main-right">
        <div class="side-block">
          <div class="block-title">创作中心</div>
          <div class="list">
            <a @click="contribute1" class="item">
              <span class="icon-wrap">
                <span class="icon icon-article-writing"></span>
              </span>
              <div class="name">文章投稿</div>
            </a>
            <a-divider type="vertical" />
            <a @click="contribute2" class="item">
              <span class="icon-wrap">
                <span class="icon icon-bbs-vote"></span>
              </span>
              <div class="name">社区发帖</div>
            </a>
          </div>
        </div>

        <div class="side-block">
          <div class="block-title">工具中心</div>
          <div class="list list2">
            <router-link to="/guide/index" class="item" target="_blank">
              <span class="icon-wrap">
                <span class="icon icon-xtzn2"></span>                
              </span>
              <div class="name">选题指南</div>
            </router-link>
            <a
              href="http://test.sozdata.com/checkpaper.html#/"
              target="_blank"
              class="item"
            >
              <span class="icon-wrap">
                <span class="icon icon-lwcc2"></span>
              </span>
              <div class="name">论文查重</div>
            </a>
            <a @click="analyse" :to="{ path: '/vote' }" class="item">
              <span class="icon-wrap">
                <span class="icon icon-tgfx2"></span>
              </span>
              <div class="name">投稿分析</div>
            </a>
            <a @click="competition" class="item">
              <span class="icon-wrap">
                <span class="icon icon-xspt"></span>
              </span>
              <div class="name">学赛系统</div>
            </a>
            <a class="item">
              <span class="icon-wrap">
                <span class="icon icon-ytpt"></span>
                <span
                  style="
                    background: rgba(0, 0, 0, 0.4);
                    width: 53px;
                    height: 53px;
                    display: block;
                    border-radius: 50%;
                    margin: 0 auto;
                    margin-top: -53px;
                  "
                  ><span style="font-size: 12px; line-height: 53px; color: #fff"
                    >即将上线</span
                  ></span
                >
              </span>
              <div class="name">阅推平台</div>
            </a>
            <span class="item"></span>
          </div>
        </div>

        <author-rec />
      </div>

      <div class="main-left">
        <a-tabs default-active-key="1" :animated="false">
          <a-tab-pane key="1" tab="知图甄选">
            <div
              class="article-item"
              v-for="item in ztzxList"
              :key="item.essayId"
            >
              <div class="title">
                <router-link
                  :to="{ path: '/view/detail', query: { id: item.essayId } }"
                  target="_blank"
                  >{{ item.title }}</router-link
                >
              </div>
              <div class="pic f-r" v-if="item.imgUrl">
                <router-link
                  :to="{ path: '/view/detail', query: { id: item.essayId } }"
                  target="_blank"
                >
                  <img
                    :src="
                      item.imgUrl.indexOf('https://') === -1
                        ? imgSiteUrl + item.imgUrl
                        : item.imgUrl
                    "
                    alt=""
                  />
                </router-link>
              </div>
              <router-link
                :to="{ path: '/view/detail', query: { id: item.essayId } }"
                target="_blank"
              >
                <div class="desc" v-html="item.summary"></div>
              </router-link>
              <div
                class="tags"
                v-if="item.topicList"
                :class="'tags' + item.topicList.length"
              >
                <a-tag v-for="i in item.topicList" :key="i.topicId">
                  <router-link
                    :to="{ path: '/view/topic', query: { id: i.topicId } }"
                    target="_blank"
                    style="color: #e75934"
                  >
                  {{'&nbsp;'+ i.topicName +'&nbsp;'}}
                  </router-link>
                </a-tag>
              </div>
              <div class="user-ctrls">
                <div class="teacher f-l">
                  <span class="date f-r"><i>·</i>{{ item.pubTime }}</span>
                  <div class="teacher-info f-l">
                    <div class="teacher-header">
                      <router-link
                        :to="{ path: '/user', query: { id: item.userId } }"
                        target="_blank"
                      >
                        <img
                          v-if="item.uImg"
                          :src="imgSiteUrl + item.uImg"
                          alt=""
                        />
                        <img v-else src="~@/assets/img/head1.png" alt="" />
                      </router-link>
                    </div>
                  </div>
                  <div class="tearcher-name f-l">
                    <router-link
                      :to="{ path: '/user', query: { id: item.userId } }"
                      target="_blank"
                      >{{ item.userName }}</router-link
                    >
                  </div>
                </div>
                <div class="article-attr-wrap f-r">
                  <div class="article-attrs">
                    <span class="browseCount"
                      ><i class="iconfont icon-liulan"></i>&nbsp;{{
                        numWan(item.browseQua)
                      }}&nbsp;</span
                    >
                    <span class="collectCount"
                      ><i class="iconfont icon-shoucang"></i>&nbsp;{{
                        numWan(item.collectQua)
                      }}</span
                    >
                    <span class="recCount"
                      ><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{
                        numWan(item.praiseQua)
                      }}</span
                    >
                    <span class="recComment">
                      <i class="iconfont icon-pinglun"></i>&nbsp;{{
                        numWan(item.commentQua)
                      }}
                    </span>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="海外图情">
            <div
              class="article-item"
              v-for="item in hwtqList"
              :key="item.essayId"
            >
              <div class="title">
                <router-link
                  :to="{ path: '/view/detail', query: { id: item.essayId } }"
                  target="_blank"
                  >{{ item.title }}</router-link
                >
              </div>
              <div class="pic f-r" v-if="item.imgUrl">
                <router-link
                  :to="{ path: '/view/detail', query: { id: item.essayId } }"
                  target="_blank"
                >
                  <img
                    :src="
                      item.imgUrl.indexOf('https://') === -1
                        ? imgSiteUrl + item.imgUrl
                        : item.imgUrl
                    "
                    alt=""
                  />
                </router-link>
              </div>
              <router-link
                :to="{ path: '/view/detail', query: { id: item.essayId } }"
                target="_blank"
              >
                <div class="desc" v-html="item.summary"></div>
              </router-link>
              <div
                class="tags"
                v-if="item.topicList"
                :class="'tags' + item.topicList.length"
              >
                <a-tag v-for="i in item.topicList" :key="i.topicId">
                  <router-link
                    :to="{ path: '/view/topic', query: { id: i.topicId } }"
                    target="_blank"
                    style="color: #e75934"
                  >
                   {{'&nbsp;'+ i.topicName +'&nbsp;'}}
                  </router-link>
                </a-tag>
              </div>
              <div class="user-ctrls">
                <div class="teacher f-l">
                  <span class="date f-r"><i>·</i>{{ item.pubTime }}</span>
                  <div class="teacher-info f-l">
                    <div class="teacher-header">
                      <router-link
                        :to="{ path: '/user', query: { id: item.userId } }"
                        target="_blank"
                      >
                        <img
                          v-if="item.uImg"
                          :src="imgSiteUrl + item.uImg"
                          alt=""
                        />
                        <img v-else src="~@/assets/img/head1.png" alt="" />
                      </router-link>
                    </div>
                  </div>
                  <div class="tearcher-name f-l">
                    <router-link
                      :to="{ path: '/user', query: { id: item.userId } }"
                      target="_blank"
                      >{{ item.userName }}</router-link
                    >
                  </div>
                </div>
                <div class="article-attr-wrap f-r">
                  <div class="article-attrs">
                    <span class="browseCount"
                      ><i class="iconfont icon-liulan"></i>&nbsp;{{
                        numWan(item.browseQua)
                      }}&nbsp;</span
                    >
                    <span class="collectCount"
                      ><i class="iconfont icon-shoucang"></i>&nbsp;{{
                        numWan(item.collectQua)
                      }}</span
                    >
                    <span class="recCount"
                      ><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{
                        numWan(item.praiseQua)
                      }}</span
                    >
                    <span class="recComment"
                      ><i class="iconfont icon-pinglun"></i>&nbsp;{{
                        numWan(item.commentQua)
                      }}</span
                    >
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" tab="国内图情">
            <div
              class="article-item"
              v-for="item in gntqList"
              :key="item.essayId"
            >
              <div class="title">
                <router-link
                  :to="{ path: '/view/detail', query: { id: item.essayId } }"
                  target="_blank"
                  >{{ item.title }}</router-link
                >
              </div>
              <div class="pic f-r" v-if="item.imgUrl">
                <router-link
                  :to="{ path: '/view/detail', query: { id: item.essayId } }"
                  target="_blank"
                >
                  <img
                    :src="
                      item.imgUrl.indexOf('https://') === -1
                        ? imgSiteUrl + item.imgUrl
                        : item.imgUrl
                    "
                    alt=""
                  />
                </router-link>
              </div>
              <router-link
                :to="{ path: '/view/detail', query: { id: item.essayId } }"
                target="_blank"
              >
                <div class="desc" v-html="item.summary"></div>
              </router-link>
              <div
                class="tags"
                v-if="item.topicList"
                :class="'tags' + item.topicList.length"
              >
                <a-tag v-for="i in item.topicList" :key="i.topicId">
                  <router-link
                    :to="{ path: '/view/topic', query: { id: i.topicId } }"
                    target="_blank"
                    style="color: #e75934"
                  >
                   {{'&nbsp;'+ i.topicName +'&nbsp;'}}
                  </router-link>
                </a-tag>
              </div>
              <div class="user-ctrls">
                <div class="teacher f-l">
                  <span class="date f-r"><i>·</i>{{ item.pubTime }}</span>
                  <div class="teacher-info f-l">
                    <div class="teacher-header">
                      <router-link
                        :to="{ path: '/user', query: { id: item.userId } }"
                        target="_blank"
                      >
                        <img
                          v-if="item.uImg"
                          :src="imgSiteUrl + item.uImg"
                          alt=""
                        />
                        <img v-else src="~@/assets/img/head1.png" alt="" />
                      </router-link>
                    </div>
                  </div>
                  <div class="tearcher-name f-l">
                    <router-link
                      :to="{ path: '/user', query: { id: item.userId } }"
                      target="_blank"
                      >{{ item.userName }}</router-link
                    >
                  </div>
                </div>
                <div class="article-attr-wrap f-r">
                  <div class="article-attrs">
                    <span class="browseCount"
                      ><i class="iconfont icon-liulan"></i>&nbsp;{{
                        numWan(item.browseQua)
                      }}&nbsp;</span
                    >
                    <span class="collectCount"
                      ><i class="iconfont icon-shoucang"></i>&nbsp;{{
                        numWan(item.collectQua)
                      }}</span
                    >
                    <span class="recCount"
                      ><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{
                        numWan(item.praiseQua)
                      }}</span
                    >
                    <span class="recComment"
                      ><i class="iconfont icon-pinglun"></i>&nbsp;{{
                        numWan(item.commentQua)
                      }}</span
                    >
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="4" tab="专家推荐">
            <div class="essay-item" v-for="item in zjtjList" :key="item.id">
              <div class="title">
                <router-link
                  :to="{
                    path: '/essay_detail',
                    query: { id: item.id, type: 2 },
                  }"
                  target="_blank"
                  >{{ item.title }}</router-link
                >
              </div>
              <div class="pic">
                <img :src="imgSiteUrl + item.jourImgUrl" alt="" />
              </div>
              <div class="author">
                《{{ item.journalNameZH }}》编辑部推荐 -
                {{ item.pubYear }}年第{{ item.period }}期发表
              </div>
              <router-link
                :to="{
                  path: '/essay_detail',
                  query: { id: item.id, type: 2 },
                }"
                target="_blank"
              >
                <div class="desc" v-html="item.summary"></div>
              </router-link>
              <div class="keywords">
                <div class="count" style="color: #aaa">
                  <span class="browseCount"
                    ><i class="iconfont icon-liulan"></i>&nbsp;{{
                      numWan(item.browseQua)
                    }}&nbsp;</span
                  >
                  <span class="collectCount"
                    ><i class="iconfont icon-shoucang"></i>&nbsp;{{
                      numWan(item.collectQua)
                    }}&nbsp;</span
                  >
                  <span class="recCount"
                    ><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{
                      numWan(item.praiseQua)
                    }}&nbsp;</span
                  >
                </div>

                推荐日期：{{
                  item.pubTime ? item.pubTime.substring(0, 10) : ""
                }}
                <div class="clear"></div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="5" tab="论文集">
            <div class="lwj-item" v-for="item in lwjList" :key="item.id">
              <div class="title">
                <router-link
                  :to="{ path: '/collection_detail', query: { id: item.id } }"
                  target="_blank"
                  >{{ item.name }}</router-link
                >
              </div>
              <router-link
                :to="{ path: '/collection_detail', query: { id: item.id } }"
                target="_blank"
              >
                <div class="desc">{{ item.summary }}</div>
              </router-link>
              <div
                class="tags"
                v-if="item.topicList"
                :class="'tags' + item.topicList.length"
              >
                <a-tag v-for="i in item.topicList" :key="i.topicId">
                  {{'&nbsp;'+ i.topicName +'&nbsp;'}}
                </a-tag>
              </div>
              <div class="user-ctrls">
                <div class="teacher f-l" v-if="item.userInfoEntity">
                  <span class="date f-r"
                    ><i>·</i
                    >{{
                      item.addTime === item.lstModTime
                        ? item.addTime.substring(0, 10) + "创建"
                        : item.lstModTime.substring(0, 10) + "更新"
                    }}</span
                  >
                  <div class="teacher-info f-l">
                    <div class="teacher-header">
                      <router-link
                        :to="{ path: '/user', query: { id: item.userId } }"
                        target="_blank"
                      >
                        <img
                          v-if="item.userInfoEntity.imgUrl"
                          :src="imgSiteUrl + item.userInfoEntity.imgUrl"
                          alt=""
                        />
                        <img v-else src="~@/assets/img/head1.png" alt="" />
                      </router-link>
                    </div>
                  </div>
                  <div class="tearcher-name f-l">
                    <router-link
                      :to="{ path: '/user', query: { id: item.userId } }"
                      target="_blank"
                      >{{ item.userInfoEntity.userName }}
                    </router-link>
                  </div>
                </div>
                <div class="lwj-attrs f-r">
                  {{ item.collectQua ? numWan(item.collectQua) : 0 }}人收藏
                  <a-divider type="vertical" />
                  {{ item.articleQua ? numWan(item.articleQua) : 0 }}篇文章
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="clear"></div>
    </div>

    
  </div>
</template>

<script>
import { computed, onMounted, reactive, toRefs } from "vue";
import Http from "../until/http";
import { messageTips, numWan, getCookie, confirmLogin, } from "../until/tools";
import config from "../until/configs";
import { useRouter } from "vue-router";
import AuthorRec from "../components/AuthorRec.vue";
export default {
  components: { AuthorRec },
  setup() {
    var imgSiteUrl = computed(() => {
      return config.imgSiteUrl;
    });
    const router = useRouter();
    const state = reactive({
      banners: [],
      active: [],
      ztzxList: [],
      hwtqList: [],
      gntqList: [],
      zjtjList: [],
      lwjList: [],
      tqexamUrl:'',
    });
    const messageTip = () => {
      messageTips("后续功能待开发", 2);
    };
    const sid = computed(() => {
      return getCookie("z_sid") || null;
    });
    const analyse = () => {
      if (!sid.value) {
        confirmLogin();
      } else {
        router.push({
          path: "/vote",
        });
      }
    };
    const contribute1 = () => {
      if (!sid.value) {
        confirmLogin();
      } else {
        router.push({
          path: "/pub",
          query: { type: 1 },
        });
      }
    };
    const contribute2 = () => {
      if (!sid.value) {
        confirmLogin();
      } else {
        router.push({
          path: "/pub",
          query: { type: 2 },
        });
      }
    };
    const competition = () => {
      if (!sid.value) {
        window.location.href =
          "http://test.sozdata.com/#/login/login_basic?sign=88";
      }else{
       window.location.href ="http://test.sozdata.com/tqexam.html#"+state.tqexamUrl;
      }
    };
    const getExamInfo=()=>{
      if(sid.value){
        Http.getExamUserInfo().then((res)=>{
          Object.assign(state, {
            tqexamUrl: res.userInfo.menu[0].url
          });
        })
      }else{
        return;
      }
    }
    onMounted(() => {
      document.title = config.siteTitle;
      getExamInfo()
      Http.getIndexBanner().then((res) => {
        if (res.essayList) {
          Object.assign(state, {
            banners: res.essayList,
          });
        }
      });
      Http.getIndexActives({ type: 1 }).then((res) => {
        if (res) {
          if (res.list && res.list[0]) {
            Object.assign(state, {
              active: res.list[0],
            });
          }
        }
      });

      Http.getViewList({ sortType: 1, pageNum: 1, classifyType: 1 }).then(
        (res) => {
          if (res.essayList) {
            Object.assign(state, {
              ztzxList: res.essayList,
            });
          }
        }
      );
      Http.getViewList({ sortType: 1, pageNum: 1, classifyType: 3 }).then(
        (res) => {
          if (res.essayList) {
            Object.assign(state, {
              hwtqList: res.essayList,
            });
          }
        }
      );
      Http.getViewList({ sortType: 1, pageNum: 1, classifyType: 2 }).then(
        (res) => {
          if (res.essayList) {
            Object.assign(state, {
              gntqList: res.essayList,
            });
          }
        }
      );

      Http.getEssayExpertRec({ pageNum: 1, sortType: 0, recTime: 0 }).then(
        (res) => {
          if (res.recommendations) {
            Object.assign(state, {
              zjtjList: res.recommendations,
            });
          }
        }
      );

      Http.getEssayCollections({ pageNum: 1, sortType: 0 }).then((res) => {
        if (res.aggItems) {
          Object.assign(state, {
            lwjList: res.aggItems,
          });
        }
      });
    });


    return {
      contribute1,
      contribute2,
      imgSiteUrl,
      messageTip,
      ...toRefs(state),
      analyse,
      numWan,
      competition,
      getExamInfo
    };
  },
};
</script>
<style lang="scss">
.banner {
  .ant-carousel .slick-dots {
    text-align: right;
    height: 6px;
    padding-right: 20px;
  }
  .ant-carousel .slick-dots li button {
    width: 40px;
    height: 6px;
  }
  .ant-carousel .slick-dots-bottom {
    bottom: 24px;
  }
}
.main-left {
  .ant-tabs-nav-container {
    padding: 0 20px !important;
  }
}
</style>
<style lang="scss" scoped>
@import "../scss/index.scss";
</style>